export default __webpack_public_path__ + "static/media/thumbnail_image_8.b2f3b087.png";